import { InjectionToken } from "@angular/core";
import { IDataSourceSettings } from "./data-source-settings.interface";

export class DataSourceSettingsRef extends InjectionToken<IDataSourceSettings> { }
